import curry from "lodash.curry";

export const set = curry((propertyPath, value, document) => {
  const indexOfDot = propertyPath.indexOf(".");
  if (indexOfDot === -1) {
    return setSingleProp(document, propertyPath, value);
  } else {
    const leftProp = propertyPath.slice(0, indexOfDot);
    const rightProp = propertyPath.slice(indexOfDot + 1);
    return setSingleProp(document, leftProp, set(rightProp, value, getPropertyValueOrDefaultFor(document, leftProp)));
  }
});

function setSingleProp(document, prop, value) {
  const safeDocument = getDefaultIfNullFor(document, prop);
  if (safeDocument[prop] === value) {
    return safeDocument;
  }

  if (Array.isArray(safeDocument)) {
    return Object.assign([...safeDocument], { [prop]: value });
  } else {
    return { ...safeDocument, [prop]: value };
  }
}

function getDefaultIfNullFor(document, prop) {
  const safeDocument = document === null || document === undefined ? (isNumeric(prop) ? [] : {}) : document;
  return safeDocument;
}

function getPropertyValueOrDefaultFor(document, prop) {
  return getDefaultIfNullFor(document[prop], prop);
}

function isNumeric(num) {
  return !isNaN(num);
}
